export default {
  data: function () {
    return {
      ALL_CATEGORIES: this.$t('homepage.allCategories'),
      ALL_BOARDS: this.$t('homepage.allBoards'),
      ALL_STORIES: 'All Stories',
      STORY_BOARDS: 'StoryBoards',

      CONTRIBUTED_TO: this.$t('navBar.contributedTo'),
      WETTBEWERBE_PROJECT: 'Wettbewerbe',
      MY_BOOKMARKS: this.$t('navBar.myBookmarks'),
      MY_STORIES: 'My Boards',
      MY_SUBMISSIONS: 'My Submissions',
      MY_PROJECTS: this.$t('navBar.myProjects'),
      MY_BOARDS: this.$t('navBar.myProjects'),
      MY_INTERESTS: this.$t('explore.myInterests'),

      FEATURED: this.$t('homepage.featured'),
      PREMIUM: this.$t('homepage.premium'),
      BOOKMARKED: this.$t('homepage.bookmarked'),
      NEWEST: this.$t('projectPage.newest'),
      POPULAR: 'Popular',
      RECOMMENDED: this.$t('homepage.recommended'),
      RECENT_ACTIVITY: this.$t('navBar.recentActivity'),

      FEATURED_STORIES: this.$t('homepage.featuredStories'),
      NEWEST_STORIES: 'Newest Stories',
      EXPLORE_STORIES: 'Explore Stories',
      COMMUNITY: 'Community',

      FEATURED_PROJECTS: this.$t('homepage.featuredProjects'),
      PREMIUM_PROJECTS: this.$t('homepage.premiumProjects'),
      NEWEST_PROJECTS: this.$t('homepage.newestProjects'),
      BOOKMARKED_PROJECTS: this.$t('homepage.bookmarkedProjects'),

      FEATURED_KEY: 'homepage.featured',
      BOOKMARKED_KEY: 'homepage.bookmarked',
      PREMIUM_KEY: 'homepage.premium',
      NEWEST_KEY: 'projectPage.newest',
      CONTRIBUTED_TO_KEY: 'navBar.contributedTo',
      WETTBEWERBE_PROJECT_KEY: 'wettbewerbe',

      AWARDED_PROJECTS: 'Awarded Projects',
      SD_AWARDED_PROJECTS: '2023 State Science Day Qualifiers',

      seeAllDivWidth: 30,
      tabletWidth: 785,

      // Card width include padding around card
      engCardAreaWidth: 279,
      engCardAreaWidthMobile: 182,
      isefCardWidth: 376,
      isefCardWidthMobile: 376
    }
  }
}
